"use strict";

var PropTypes = require("prop-types");

var ProjectActions = require("./ProjectActions");
var ProjectStore = require("./ProjectStore");

var Frequency = require("../commonComponents/Frequency");

class DonationFrequency extends React.Component {
	render() {
		return (
			<Frequency
				{...this.props}
				thisArg={this}
				beginningComponentName="Donation"
				tangibleActions={ProjectActions}
				tangibleStore={ProjectStore}
				tangibleType="project"
				displayCodeProperty="ProjectCode"
				reactComponentCategory="ProjectFrequencyComponents"
			/>
		);
	}
}

DonationFrequency.defaultProps = {
	type: "button",
	theme: "0",
	isCustomTheme: false
};

DonationFrequency.propTypes = {
	isDesignMode: PropTypes.bool, //can do .isRequired
	project: PropTypes.object,
	frequencies: PropTypes.array,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]),
	context: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = DonationFrequency;
